// One-time "Download the Desktop Companion" pop-up: remembers, per DJ account,
// that the pop-up has already been shown on this device. Persisted in
// localStorage so it survives reloads and navigation — it should appear once,
// right after the DJ handles the DEMO request (was first sign-in),
// for EVERY DJ (US and non-US), never repeatedly.
const KEY_PREFIX = "rq_desktop_prompt_seen_";

export function hasSeenDesktopPrompt(accountKey: string): boolean {
  try {
    return localStorage.getItem(KEY_PREFIX + accountKey) === "1";
  } catch {
    return false;
  }
}

export function markDesktopPromptSeen(accountKey: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + accountKey, "1");
  } catch {
    // localStorage unavailable (e.g. Safari private mode) — the prompt may
    // reappear next visit, which is an acceptable degradation.
  }
}
